import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faClock } from '@fortawesome/free-solid-svg-icons';
import {
  setEditClient,
  logEmail
} from '../../actions/advisor';
import {
  LA_TEST,
  RR_TEST,
  BS_TEST,
  LF_TEST,
} from '../../constants.js';
import s from './Client.css';

library.add(faCheckCircle, faClock);

class Client extends PureComponent {

  constructor(props) {
    super(props);
  }

  setEditClient(client) {
    this.props.setEditClient(client);
  }

  getStatusTest(client) {
    const completed = [LA_TEST, BS_TEST, RR_TEST, LF_TEST].map((test) => {
      const complete = client.results.filter((result) => result.name === test);
      return complete.length > 0 ? true : false;
    });
    return completed.includes(false) ? false : true;
  }

  getStatusGoals(client) {
    if (client) {
      let hasGoal = false;
      if (client.retireMonthlyIncome && client.retireMonthlyIncome > 0) {
        hasGoal = true;
      }
      if (hasGoal) {
        return true;
      }
      return false;
    } else {
      return false;
    }
  }

  getStatusPortfolio(client) {
    if (client) {
      let hasPort = false;
      if (client.holdings && client.holdings.length > 0) {
        hasPort = true;
      }
      if (hasPort) {
        return true;
      }
      return false;
    } else {
      return false;
    }
  }

  getStatusIcon(isComplete, name) {
    if (isComplete) {
      return(
        <div className={s.testStatus}>
          <div className={s.testStatusIcon}><FontAwesomeIcon icon="check-circle" size="lg" color="#37BAC0" /></div>
          <div className={s.testStatusText}><span style={{fontWeight:'700'}}>COMPLETE:</span><br />{name}</div>
        </div>
      );
    } else {
      return (
        <div className={s.testStatus}>
          <div className={s.testStatusIcon}><FontAwesomeIcon icon="clock" size="lg" color="#F44821" /></div>
          <div className={s.testStatusText}><span style={{fontWeight:'700'}}>INCOMPLETE:</span><br />{name}</div>
        </div>
      );
    }
  }

  renderProgress() {
    const {
      client,
    } = this.props;

    return (
      <div className={s.clientProgress}>
          {this.getStatusIcon(this.getStatusTest(client), 'Behavioral Finance Assessment')}
          {this.getStatusIcon(this.getStatusGoals(client), 'Client Profile')}
          {this.getStatusIcon(this.getStatusPortfolio(client), 'Client Portfolio')}
      </div>
    );
  }

  render() {
    const {
      client,
    } = this.props;

    return (
      <div className='col-lg-4 col-md-12'>
        <div className={s.clientCard}>
          <div className={'row'}>
            <div className={'col-md-12'}>
              <div className={s.clientTitleName}>
                {client.firstName} {client.lastName}
              </div>
              <div className={s.clientEmail}>
                {client.email}
              </div>
            </div>
          </div>
          {this.renderProgress()}
          <div className={'row'}>
            <div className={'col-lg-12'}>
              <div className={'row'}>
                <div className={'col-lg-12'}>
                  <div className={s.clientAction2} onClick={() => this.setEditClient(client)}>
                    OPEN
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
  };
}

export default connect(mapStateToProps, {
  setEditClient,
  logEmail,
})(Client);



// WEBPACK FOOTER //
// ./src/components/AdvisorMode/Client.js